export default __webpack_public_path__ + "static/media/dashboard-gradient-box-background.dee050bc.svg";